import { CicdProjects } from "~/pages/cicd/CicdProjects";
import { Space } from "~/lib/types";

interface ProjectsProps {
  space: Space;
}

const ProjectsEntryPage = ({ space }: ProjectsProps) => {
  return <CicdProjects space={space} />;
};

export default ProjectsEntryPage;
